<template>
    <restaurant-detail
        class="restaurant-facilities"
        :title="$snippet('restaurant_facilities_title', 'facilities')"
    >
        <ul v-test:facilitiesList>
            <li
                v-for="facility in facilities"
                :key="facility.name"
                v-test:facilityItem
            >
                <div
                    v-if="facility.icon.src"
                    class="icon"
                >
                    <lazy-image
                        v-if="facility.icon.src"
                        :src="facility.icon.src"
                        :alt="facility.icon.alt || ''"
                        :width="facility.icon.width"
                        :height="facility.icon.height"
                        v-test:facilityIcon
                    />
                </div>

                {{ facility.name }}
            </li>
        </ul>
    </restaurant-detail>
</template>

<script>
    import RestaurantDetail from '../../molecules/RestaurantDetail/RestaurantDetail';

    export default {
        name: 'restaurant-facilities',

        components: { RestaurantDetail },

        props: {
            facilities: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    ul {
        list-style: none;
        padding: 0;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        gap: 5px 15px;
        flex-wrap: wrap;
    }

    li {
        display: flex;
        align-items: center;
        gap: 7.5px;
    }

    .icon {
        height: 1.5em;
        width: 1.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        border: 1px solid currentColor;
        overflow: hidden;

        img {
            max-width: 70%;
            max-height: 70%;
            height: auto;
            width: auto;
        }
    }
</style>
